/* eslint-disable */
import { withStyles } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import round from 'lodash/round';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import i18nLocaleSelector from '../../State/Store/I18n/Selectors/I18nLocale.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_EXPANSION_PANEL_COLLAPSED, UI_EXPANSION_PANEL_EXPANDED } from '../../State/Store/UI/UI.types';
import toDisplayUnit from '../../Support/Converters/ToDisplayUnit/ConvertersToDisplayUnit.support';
import generateHash from '../../Support/Generators/GenerateHash/GeneratorsGenerateHash.support';
import isNumber from '../../Support/Is/Number/IsNumber.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import OrderConcreteDeliveriesInTransitSectionPropTypes from './OrderConcreteDeliveriesInTransitSection.component.props';
import orderConcreteDeliveriesInTransitSectionStyles from './OrderConcreteDeliveriesInTransitSection.component.styles';

/**
 * OrderConcreteDeliveriesInTransitSectionComponent
 * @export
 * @class OrderConcreteDeliveriesInTransitSectionComponent
 * @extends {React.Component<OrderConcreteDeliveriesInTransitSectionComponentComposedProps, OrderConcreteDeliveriesInTransitSectionComponentState>}
 */
export class OrderConcreteDeliveriesInTransitSectionComponent extends React.Component {
  preserveScrollRef = React.createRef();

  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<OrderConcreteDeliveriesInTransitSectionComponentProps>}
   * @memberof OrderConcreteDeliveriesInTransitSectionComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrderConcreteDeliveriesInTransitSectionComponent`}
   * @memberof OrderConcreteDeliveriesInTransitSectionComponent
   */
  static displayName = `OrderConcreteDeliveriesInTransitSectionComponent`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderConcreteDeliveriesInTransitSectionComponent
   */
  static propTypes = OrderConcreteDeliveriesInTransitSectionPropTypes;

  /**
   * Data specific to the `<OrderConcreteDeliveriesInTransitSectionComponent />` instance
   * @type {OrderConcreteDeliveriesInTransitSectionComponentState}
   * @memberof OrderConcreteDeliveriesInTransitSectionComponent
   */
  state = {
    expanded: false,
  };

  /**
   * Returns the ETA
   * @param {Object} load The load
   * @returns {string} The ETA
   * @memberof OrderConcreteDeliveriesInTransitSectionComponent
   */
  getEta = (load) => {
    const {
      reviewedOnJobTime,
      truck: { eta },
    } = load;
    if (eta.trim().length > 0) {
      return eta.trim();
    }
    return reviewedOnJobTime.trim();
  };

  /**
   * Returns the unit of measure
   * @returns {string} The unit of measure
   * @memberof OrderConcreteDeliveriesInTransitSectionComponent
   */
  getUnitOfMeasure = () => {
    const { currentOrder } = this.props;
    const { details } = currentOrder;
    const { qty } = details || {};
    const { uom } = qty || {};
    return toDisplayUnit(uom);
  };

  /**
   * Returns the unit of measure
   * @param {any} event The event
   * @param {boolean} expanded The expanded state
   * @returns {string} The unit of measure
   * @memberof OrderConcreteDeliveriesInTransitSectionComponent
   */
  onExpansionPanelChange = (event, expanded) => {
    const { actions } = this.props;
    const type = expanded ? UI_EXPANSION_PANEL_EXPANDED : UI_EXPANSION_PANEL_COLLAPSED;
    actions.uiTriggered({
      payload: {
        data: {
          name: `OrderConcreteDeliveriesInTransitSection`,
        },
      },
      type,
    });
    this.setState({
      expanded,
    });
  };

  /**
   * Renders the expand icon
   * @returns {React.Component} component
   * @memberof OrderConcreteDeliveriesInTransitSectionComponent
   */
  renderExpandIcon = () => {
    const { expanded } = this.state;
    if (expanded) {
      return <RemoveIcon />;
    }
    return <AddIcon />;
  };

  /**
   * Renders the delivery load item
   * @param {any} load The current load
   * @returns {React.Component} component
   * @memberof OrderConcreteDeliveriesInTransitSectionComponent
   */
  renderLoad = (load) => {
    const {
      classes,
      locale: { lang },
    } = this.props;
    const {
      loadQty,
      truck: { code },
    } = load;
    const eta = this.getEta(load);
    const options = { hour: `numeric`, minute: `numeric`, timeZone: `UTC` };
    const etaTime = isNumber(+eta) ? new Intl.DateTimeFormat(lang, options).format(new Date(+eta)) : `-`;
    const unitOfMeasure = this.getUnitOfMeasure();
    const uniqueKey = generateHash(load);
    return (
      <Grid classes={{ container: classes.detailsItemContainer }} container justify="space-between" key={uniqueKey}>
        <Grid item sm={4} xs>
          <Typography>{etaTime}</Typography>
          <I18n variant="caption">OrderService.ConcreteDeliveries.Labels.Eta</I18n>
        </Grid>
        <Grid item sm={6} xs>
          <Typography>{`${round(loadQty, 1).toFixed(1)}${unitOfMeasure}`}</Typography>
          <I18n data={{ code }} variant="caption">
            OrderService.ConcreteDeliveries.Labels.Truck
          </I18n>
        </Grid>
      </Grid>
    );
  };

  /**
   * Renders the in transit details section
   * @param {Order} currentDeliveryDetails The current order
   * @returns {React.Component} component
   * @memberof OrderConcreteDeliveriesInTransitSectionComponent
   */
  renderInTransit = (currentDeliveryDetails) => {
    if (!currentDeliveryDetails || !currentDeliveryDetails.data) {
      return null;
    }
    const {
      data: {
        orders: {
          loads: { intransit },
          totalIntransit,
        },
      },
    } = currentDeliveryDetails;
    const unitOfMeasure = this.getUnitOfMeasure();
    const inTransitLoads = intransit.map(this.renderLoad);
    const { classes } = this.props;
    return (
      <ExpansionPanel classes={{ root: classes.section }} onChange={this.onExpansionPanelChange}>
        <ExpansionPanelSummary classes={{ root: classes.detailsHeader }} expandIcon={parseFloat(totalIntransit) > 0 && this.renderExpandIcon()}>
          <Grid alignItems="center" container justify="space-between" spacing={4}>
            <Grid item sm={3} xs>
              <I18n variant="body1">OrderService.ConcreteDeliveries.Labels.InTransitHeader</I18n>
            </Grid>
            <Grid item sm={6} xs>
              <Typography>{`${round(totalIntransit, 1).toFixed(1)}${unitOfMeasure}`}</Typography>
            </Grid>
          </Grid>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.noPadding}>
          <div className={classes.detailsContainer}>{inTransitLoads}</div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrderConcreteDeliveriesInTransitSectionComponent />`
   * @memberof OrderConcreteDeliveriesInTransitSectionComponent
   */
  render() {
    const { currentDeliveryDetails } = this.props;
    return this.renderInTransit(currentDeliveryDetails);
  }
}

/** @type {React.ComponentClass<OrderConcreteDeliveriesInTransitSectionProps>} */
const OrderConcreteDeliveriesInTransitSection = compose(
  withStyles(themeCreateInjectableStyles(orderConcreteDeliveriesInTransitSectionStyles), { withTheme: true }),
  connect(
    (state) => ({
      locale: i18nLocaleSelector(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(OrderConcreteDeliveriesInTransitSectionComponent);

export default OrderConcreteDeliveriesInTransitSection;
